import { post, get, put, deleteApi } from '../axiosFun'
/* 培训课程 */
// 分页
const coursePage = (data) => {
    return post('/train/course/page', data)
}
//待审核分野
const todoMyApproval = (data) => {
    return post('/train/course/todoMyApproval', data)
}
// 列表
const courseList = (data) => {
    return post('/train/course/list', data)
}
// 详情
const courseDetail = (courseId) => {
    return get('/train/course/detail/' + courseId)
}
// 新增
const courseAdd = (data) => {
    return post('/train/course/add', data)
}
// 编辑
const courseEdit = (data) => {
    return put('/train/course/edit', data)
}
// 删除
const courseRemove = (data) => {
    return deleteApi('/train/course/remove', data)
}
// 发布
const coursePublish = (data) => {
    return post('/train/course/publish', data)
}

// 培训统计表
const trainingStatistics = (params, header = {}) => {
    return post(`/train/statistics/trainingStatistics`, params, header)
}
const approval = (params, header = {}) => {
    return post(`/train/course/approval`, params, header)
}
const addHasApprovalUser = (params, header = {}) => {
    return post(`/train/course/addHasApprovalUser`, params, header)
}
const hidden = (params, header = {}) => {
    return post(`/train/course/hidden`, params, header)
}
export default {
    coursePage,
    courseList,
    courseDetail,
    courseAdd,
    courseEdit,
    courseRemove,
    coursePublish,
    trainingStatistics,
    todoMyApproval,
    addHasApprovalUser,
    approval,
    hidden,
}



// WEBPACK FOOTER //
// ./src/api/onlineTraining/course.js